import { Encrption } from '../app-modules/encrption';
import { API_ENDPOINTS } from "./api-endpoints";
import { customAxios } from "./useExPressApi";



const getRoles = () => {
    return customAxios.get(API_ENDPOINTS.GET_ROLE);
};

const getRoleModules = (id) => {
    return customAxios.get(API_ENDPOINTS.GET_ROLE_MODULES + Encrption(id));
};


const updateRoleModulePermission = (roleId, selectedPermissions) => {

    var data = {
        "roleId": roleId,
        "permissions": selectedPermissions
    }

    return customAxios.post(API_ENDPOINTS.UPDATE_ROLE_PERMISSIONS, data,);
};


export const RoleService = {
    getRoles,
    getRoleModules,
    updateRoleModulePermission,
    // getUserPermissions


}